import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainGrid: {
    width: "100%",
    maxWidth: "520px",
    alignItems: "flex-start",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    color: "#1D2939",
    fontSize: "24px",
    lineHeight: "32px",
    marginBottom: "0px",
    marginTop: "0px",
  },
  text: {
    fontFamily: "Manrope",
    color: "#667085",
    fontSize: "14px",
    lineHeight: "20px",
  },
  boxContainer: {
    width: "100%",
    maxWidth: "520px",
    alignSelf: "flex-start",
  },
  input: {
    color: "#063663",
    fontSize: "16px",
  },
  button: {
    backgroundColor: "#476589",
  },
  gridItemForm: {
    backgroundColor: "#063663",
    padding: "50px 80px",
    "@media (max-width: 960px)": {
      padding: "50px 25px",
    },
  },
  gridItemInfoText: {
    "@media (max-width: 960px)": {
      display: "none !important",
    },
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#EEEEEE",
    padding: "60px",
    alignItems: "center",
  },
  infoText: {
    textAlign: "center",
    fontSize: "22px",
    color: "#000000",
    lineHeight: "1.7",
  },
  clickableText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#0055A4",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  returnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
  },

  contentCarousel: {
    width: "fit-content",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  imageCarousel: {
    width: "100%",
    height: "70%",
  },
  imageUpdatePassword: {
    width: "75%",
  },
  imageConfirmEmail: {
    width: "80%",
  },
  message: {
    paddingTop: "30px",
    margin: "0 auto",
    height: "100px",
    width: "70%",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#308CDB",
    textAlign: "center",
    whiteSpace: "normal",
  },

  slideshow: {
    margin: "0 auto",
    overflow: "hidden",
    maxWidth: "inherit",
  },

  slideshowSlider: {
    whiteSpace: "nowrap",
    transition: "ease 1000ms",
  },

  slide: {
    display: "inline-block",
    height: "37.2vh",
    width: "100%",
    marginTop: "10%",
  },

  imageUpdatePasswordContainer: {
    height: "37.2vh",
    width: "100%",
    marginTop: "8%",
    display: "flex",
    justifyContent: "center",
  },

  imageConfirmEmailContainer: {
    height: "40.2vh",
    width: "100%",
    marginTop: "8%",
    display: "flex",
    justifyContent: "center",
  },

  slideshowDots: {
    textAlign: "center",
  },

  slideshowDot: {
    display: "inline-block",
    height: "6px",
    width: "16px",
    borderRadius: "3px",

    cursor: "pointer",
    margin: "15px 8px 0px",

    backgroundColor: "#DEDEDE",
  },
  slideshowDotActive: {
    backgroundColor: "#FFF",
    width: "48px",
    borderRadius: "3px",
  },
}));

export default styles;
